var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-icon-group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-icon-group2",
    transform: "translate(-91.000000, -276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-icon-group3",
    transform: "translate(91.000000, 276.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "image-icon-polygon1",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2162162,25.5255255 L28.2162162,6.69069069 C28.2162162,5.21081081 27.0054054,4 25.5255255,4 L6.69069069,4 C5.21081081,4 4,5.21081081 4,6.69069069 L4,25.5255255 C4,27.0054054 5.21081081,28.2162162 6.69069069,28.2162162 L25.5255255,28.2162162 C27.0054054,28.2162162 28.2162162,27.0054054 28.2162162,25.5255255 Z",
    id: "image-icon-path1",
    fill: "#3839BD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "image-icon-group4",
    transform: "translate(8.000000, 10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66564885,0 C3.86259542,0 4.81526718,0.977099237 4.81526718,2.14961832 C4.81526718,3.34656489 3.86259542,4.32366412 2.66564885,4.32366412 C1.46870229,4.32366412 0.491603053,3.34656489 0.491603053,2.14961832 C0.491603053,0.977099237 1.46870229,0 2.66564885,0 Z",
    id: "image-icon-path2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.340458,13.1954198 L0.659541985,13.1954198 C0.293129771,13.1954198 0,12.8778626 0,12.5114504 L0,11.3149979 L2.66259542,8.65240245 L4.8610687,10.8508757 C5.12977099,11.119578 5.54503817,11.119578 5.81374046,10.8508757 L11.3343511,5.33026505 L16,9.9959139 L16,12.5114504 C16,12.8778626 15.7068702,13.1954198 15.340458,13.1954198 Z",
    id: "image-icon-path3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.acf773e2.svg";
export { ForwardRef as ReactComponent };